<template>
  <div>
      <!-- :key="$route.fullPath 用于相同路由不同传参时，识别路由的区别，从而正确的跳转，不过好像会有性能问题 -->
      <!-- <router-view :key="$route.fullPath"></router-view> -->
      <!-- 下面用于设置导航路径展示 -->
      <!-- <el-breadcrumb v-show="$route.path != '/'" separator-class="el-icon-arrow-right">
        <span class="line">|</span>
        <el-breadcrumb-item>心理测评</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: $route.path }">{{ $route.meta.title }}</el-breadcrumb-item>
      </el-breadcrumb> -->
      <div style="width:200px;background-color:#F4F4F5;overflow-y:auto;">
        <el-menu :default-active="activeIndex" @select="handleSelect" background-color="#F4F4F5" text-color="#606266" active-text-color="#fdb933" :default-openeds=menu_indexs style="margin-top:30px;">
            <el-submenu :key="index" v-for="(menu, index) in painspot_info" :index="menu.index">
                <template slot="title">{{ menu.name }}</template>
                <el-menu-item :key="sub_index" v-for="(sub_menu, sub_index) in menu.sub_painspot_info" :index="sub_menu.sub_index">{{ sub_menu.name }}</el-menu-item>
            </el-submenu>
        </el-menu>
      </div>
      <div style="flex:1;">
        <router-view></router-view>
      </div>
  </div>
</template>

<script>
import getdata from "@/api/getData.js";
import postdata from "@/api/postData.js";

export default {
    created(){
      this.getGLYFFullNav();
      if(this.$route.query.class && this.$route.query.sub_class){
        // this.activeIndex = this.$route.query.class + '>' + this.$route.query.sub_class;
        this.activeIndex = `${this.$route.query.class}>${this.$route.query.sub_class}`;
        // console.log("created activeIndex: " + this.activeIndex);
      }
    },
    data() {
        return {
            // painspot_info: [
            //   {'index': '痛点1', 'name': '痛点1', 'sub_painspot_info': [{'sub_index': '痛点1>痛点1-1', 'name': '痛点1-1'}, {'sub_index': '痛点1>痛点1-2', 'name': '痛点1-2'}]},
            //   {'index': '痛点2', 'name': '痛点2', 'sub_painspot_info': [{'sub_index': '痛点2>痛点2-1', 'name': '痛点2-1'}, {'sub_index': '痛点2>痛点2-2', 'name': '痛点2-2'}, {'sub_index': '痛点2>痛点2-3', 'name': '痛点2-3'}]},
            //   {'index': '痛点3', 'name': '痛点3', 'sub_painspot_info': [{'sub_index': '痛点3>痛点3-1', 'name': '痛点3-1'}]}
            //   ],
            painspot_info: [],
            menu_indexs: ['0000', '0001', '0002'],
            activeIndex: '',
        }
    },
    // watch: {
    //   $route(to, from) {
    //     if(to.query.class && to.query.sub_class){
    //       this.activeIndex = to.query.class + '>' + to.query.sub_class;
    //       console.log("watch activeIndex: " + this.activeIndex);
    //     }
    //   }
    // },
    methods: {
      handleSelect(key, keyPath) {
        var class_info = key.split('>');
        this.$router.push({
            name: 'GLYF_PainPoint_Article',
            query: {
              class: class_info[0],
              sub_class: class_info[1]
            }
        })
        // console.log(key, keyPath, class_info);
      },
      getGLYFFullNav() {
        getdata.getList("getGlyfFullNav")
        .then(resp => {
            if(resp.data.code == 200){
                this.painspot_info = resp.data.data;
                this.menu_indexs = resp.data.show_nav;
            }
        })
        .catch(err => {
            console.log(err);
        });
      }
    }
}
</script>

<style scoped>
.el-breadcrumb {
  height: 10px;
  padding: 15px;
  border-radius: 5px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}
.line {
  position: absolute;
  color: white;
  border-left: 3px solid red;
  left: 10px;
}
.el-menu {
    border-bottom: none;
}
.el-menu-item {
    font-size: 15px;
    line-height: 40px;
    height: 40px;
}
.el-submenu /deep/ .el-submenu__title {
    font-size: 17px;
    line-height: 45px;
    height: 45px;
    text-align: left;
}
</style>